import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.large};
`

// Unified Property Description Card
export const DescriptionCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.background.primary};
  overflow: hidden;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.medium}
    ${({ theme }) => theme.spacing.large};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.secondary};
`

export const CardTitle = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const CardActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
`

export const CardContent = styled.div`
  padding: ${({ theme }) => theme.spacing.large};
`

export const DescriptionContent = styled.div`
  min-height: 80px;

  /* Rich text content styling */
  p {
    margin: 0 0 ${({ theme }) => theme.spacing.small} 0;
    line-height: 1.6;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 ${({ theme }) => theme.spacing.small} 0;
    padding-left: ${({ theme }) => theme.spacing.large};
  }

  li {
    margin-bottom: ${({ theme }) => theme.spacing.xsmall};
    line-height: 1.5;
  }

  strong {
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  }

  em {
    font-style: italic;
  }
`

export const EmptyDescription = styled.div`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-style: italic;
`

export const Divider = styled.hr`
  margin: ${({ theme }) => theme.spacing.large} 0;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const AttributesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`

export const AttributesTitle = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
`

// Legacy styles kept for backwards compatibility
export const ActionButtons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  justify-content: flex-end;
  padding: 0px ${({ theme }) => theme.spacing.medium};
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => theme.spacing.default};
  border-bottom: 2px solid ${({ theme }) => theme.colors.border.light};
`

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.xlarge};
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  color: ${({ theme }) => theme.colors.text.tertiary};
`

export const EmptyStateIcon = styled.div`
  font-size: 38px;
  opacity: 0.5;
`

export const EmptyStateText = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.body};
`

export const EmptyStateHint = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
`
